var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            { ref: "queryForm", attrs: { model: _vm.userFrom, inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("yongName"), prop: "nickname" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("qsryongName"),
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.userFrom.nickname,
                      callback: function ($$v) {
                        _vm.$set(_vm.userFrom, "nickname", $$v)
                      },
                      expression: "userFrom.nickname",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("xdsj"), prop: "create_time" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      size: "small",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                      placeholder: _vm.$t("qxz"),
                    },
                    model: {
                      value: _vm.userFrom.create_time,
                      callback: function ($$v) {
                        _vm.$set(_vm.userFrom, "create_time", $$v)
                      },
                      expression: "userFrom.create_time",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v(_vm._s(_vm.$t("searchText")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "small" },
                      on: { click: _vm.resetQuery },
                    },
                    [_vm._v(_vm._s(_vm.$t("resetText")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["productCenter:order:kong"],
                      expression: "['productCenter:order:kong']",
                    },
                  ],
                  attrs: { label: _vm.$t("plkz") },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { size: "small", placeholder: _vm.$t("qxz") },
                      model: {
                        value: _vm.userFrom.settle_control,
                        callback: function ($$v) {
                          _vm.$set(_vm.userFrom, "settle_control", $$v)
                        },
                        expression: "userFrom.settle_control",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.$t("ying"), value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: _vm.$t("shu"), value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: _vm.$t("quanying"), value: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: _vm.$t("quanshu"), value: "4" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.batchPing },
                    },
                    [_vm._v(_vm._s(_vm.$t("sdpc")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.data, size: "mini" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: _vm.$t("xuhao"),
                  "min-width": "50",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "order_sn",
                  label: _vm.$t("ddbh"),
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "account",
                  label: _vm.$t("yhzh"),
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: _vm.$t("yongName"),
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "product_name",
                  label: _vm.$t("cpmc"),
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("gmfx"), "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.type == 1
                                ? _vm.$t("maizhang")
                                : _vm.$t("maidie")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("ddsj"),
                  prop: "time",
                  "min-width": "130",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("ddzt"), "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.status == 1
                                ? _vm.$t("jiancang")
                                : _vm.$t("pingcang")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "jcdw",
                  label: _vm.$t("jcdw"),
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pcdw",
                  label: _vm.$t("pcdw"),
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "wtye",
                  label: _vm.$t("wtye"),
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "wxwtye",
                  label: _vm.$t("xdsxf"),
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "yxwtye",
                  label: _vm.$t("yxwtye"),
                  "min-width": "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "mhye",
                  label: _vm.$t("mhye"),
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "earnings_money",
                  label: _vm.$t("ddyk"),
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: _vm.$t("xdsj"),
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dkcz"),
                  "min-width": "120",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.status == 1,
                                expression: "scope.row.status == 1",
                              },
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["productCenter:order:kong"],
                                expression: "['productCenter:order:kong']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: _vm.$t("qxz") },
                            on: {
                              change: function ($event) {
                                return _vm.changeKong(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.settle_control,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "settle_control", $$v)
                              },
                              expression: "scope.row.settle_control",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: _vm.$t("qxz"), value: 0 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: _vm.$t("ying"), value: 1 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: _vm.$t("shu"), value: 2 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: _vm.$t("quanying"), value: 3 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: _vm.$t("quanshu"), value: 4 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.status != 1,
                                expression: "scope.row.status != 1",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("wasJieSuan")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("caozuo"),
                  "min-width": "120",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row, "detail")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("chakan")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row, "edit")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("edit")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.userFrom.limit,
                  "current-page": _vm.userFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dialogVisible
        ? _c("show-detail", {
            ref: "grades",
            attrs: {
              formType: _vm.formType,
              visible: _vm.dialogVisible,
              user: _vm.userInfo,
            },
            on: {
              cancel: function ($event) {
                return _vm.handleCancel()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }